import { create } from 'zustand';

export interface GeologyState {
  unitCode: string | null;
  unitName: string | null;
  rockGroup: string | null;
  stratAge: string | null;
  stratName: string | null;
  isLoading: boolean;
  error: string | null;
  setGeology: (data: Partial<Omit<GeologyState, 'setGeology' | 'clear' | 'isLoading' | 'error'>>) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

export const useGeologyStore = create<GeologyState>((set) => ({
  unitCode: null,
  unitName: null,
  rockGroup: null,
  stratAge: null,
  stratName: null,
  isLoading: false,
  error: null,

  setGeology: (data) => set((state) => ({ ...state, ...data, isLoading: false, error: null })),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error, isLoading: false }),
  clear: () => set({
    unitCode: null,
    unitName: null,
    rockGroup: null,
    stratAge: null,
    stratName: null,
    isLoading: false,
    error: null,
  }),
}));
